<div class="d-flex align-items-center justify-content-between mb-5">
    <div class="d-flex align-items-center">
        <button
            class="go-back small-action-btn bg-gray-500 text-white mr-3"
            (click)="goBack()"
            aria-label="Back to Contact us"
        >
            <img
                src="./assets/images/icons/common/chevron-back.svg"
                alt="Back"
                title="Back to Contact us"
            />
        </button>
        <h1 class="montserrat-light text-gray-500 text-capitalize mb-0">Terms and Conditions</h1>
    </div>
</div>

<div class="legal-document">
    <div class="legal-subtitle">The Media Connector (TMC)</div>

    <h2>1. Introduction</h2>
    <p>
        Welcome to The Media Connector (TMC) (“TMC,” “we,” “our,” “us”). These Terms &amp;
        Conditions (“Terms”) govern your access to and use of our website, booking platform, and
        digital out-of-home (DOOH) advertising services, including direct bookings, programmatic
        campaigns, and related media services (collectively, the “Services”).
    </p>
    <p>
        By using our Services, you confirm your agreement to these Terms and to comply with
        applicable laws and regulations of the United Arab Emirates (UAE).
    </p>

    <h2>2. Definitions</h2>
    <ul>
        <li>
            <b>Client / User:</b> Any individual or corporate entity accessing TMC’s Services.
        </li>
        <li>
            <b>Platform:</b> The online interface operated by TMC enabling advertising bookings and
            campaign management.
        </li>
        <li>
            <b>Programmatic Services:</b> Automated real time bidding and ad placement via
            demand-side / supply-side platforms.
        </li>
        <li>
            <b>Booking Services:</b> Direct purchase of DOOH media inventory through TMC.
        </li>
        <li>
            <b>Content:</b> All creative material (visuals, audio, text, data) provided by Clients
            for advertising purposes.
        </li>
    </ul>

    <h2>3. Eligibility</h2>
    <p>You may use the Services only if you:</p>
    <ul>
        <li>Are at least 18 years old.</li>
        <li>Are legally authorized to contract under UAE law.</li>
        <li>If representing a company, are duly authorized to bind that entity.</li>
        <li>
            Registration as a Condition to Use. Only registered users (each, a “User”) may use
            the Platform. By using the Platform, you warrant that you are a User. As a User, you
            shall not allow third parties to access the Platform using your account, and you are
            personally responsible for any use of the Platform through your account, whether by you
            or a third party.
        </li>
        <li>
            Are not restricted by UAE authorities or other applicable jurisdictions from
            advertising.
        </li>
    </ul>

    <h2>4. The Platform</h2>
    <p>
        <b>4.1 Description.</b> The Platform is an advertising platform through which you authorize
        us to use automated tools to format and display multimedia content, including text, data,
        photographs, graphics, video or other information (“Content”) on digital signs and
        billboards (“Signs”). We may make certain tools available to assist you in using the
        Platform. We and/or our affiliates may participate in or make use of the Platform.
    </p>
    <p>
        <b>4.2 Target and Budget.</b> The Platform allows you to establish budgetary settings
        (“Budgets”) and specify where, when, and under what conditions your Content may be
        displayed (“Targets”). You are solely responsible for your Targets and Budgets.
    </p>
    <p>
        <b>4.3 Medium Ownership.</b> TMC does not own or operate the Signs available in the
        Platform. All Signs available in the Platform are owned or operated by Third Party Entities.
        TMC only facilitates distribution of Content on unsold inventory of all Signs connected in
        the Platform.
    </p>
    <p>
        <b>4.4</b> TMC does not use exclusively audience data collected by TMC or its affiliates. In
        any situation, the User will be notified visually regarding who is the entity providing the
        audience data and whether the data is collected in real time or it is statistical data. TMC
        is not responsible for the accuracy of the data provided and data provided should be
        regarded with a margin of error.
    </p>
    <p>
        <b>4.5 Performance and ROI.</b> TMC is not responsible for any performance /
        underperformance and ROI level. The User acknowledges that any such indicators are solely
        their responsibility and at their control. TMC has no ability to influence any such
        indicators. This falls entirely in the responsibility of the ad creator – as he or she
        controls the creative and the planning schedule.
    </p>
    <p>
        <b>4.6 Proof of play.</b> In some cases, TMC will provide a visual Proof of Play for
        scheduled campaign consisting of an image or video with the ad display on a Sign. The User
        understands that such Proof of Play is not implied for all units connected to the Platform
        and in most cases, the Proof of Play data is provided by TMC Affiliates or Suppliers in the
        form of automated airing numbers. In the situation visual Proof of Play is provided, TMC
        shall clearly mark and display this as a separate and extra feature.
    </p>

    <h2>5. Use of Services</h2>
    <p>
        <b>5.1 Account Registration.</b> Users must provide accurate details. Misrepresentation may
        lead to account suspension.
    </p>
    <p>
        <b>5.2 License.</b> TMC grants Clients a limited, revocable, non-exclusive right to use the
        Platform solely for lawful advertising.
    </p>
    <p>
        <b>5.3 Compliance with UAE Laws.</b> Clients shall ensure all Content and campaigns comply
        with:
    </p>
    <ul>
        <li>
            Federal Law on Cybercrimes (prohibiting false, misleading, defamatory, or illegal
            material).
        </li>
        <li>UAE Advertising Standards issued by the National Media Council / MOIAT.</li>
    </ul>
    <p><b>5.4 Prohibited Uses.</b> Clients shall not upload content that is:</p>
    <ul>
        <li>Political, religiously offensive, or contrary to public order / morality.</li>
        <li>Infringing copyright, trademark, or other intellectual property rights.</li>
        <li>
            Related to prohibited products (alcohol, tobacco, gambling, controlled substances)
            unless explicitly approved by concerned regulators.
        </li>
    </ul>
    <p>
        <b>5.5 Removal of Content.</b> We may remove Content at any time if we, in our sole
        discretion, determine that such content violates the Design Guidelines, is illegal or is
        otherwise offensive to the moral standards of the community. We carefully evaluate all
        requests for advertising placement on a case-by-case basis and make the best decision for
        our clients, our company and the communities in which we operate.
    </p>
    <p>
        <b>5.6 No Guarantee of Display.</b> We guarantee that your content will be present on
        selected signs based on the minimum plays per hour booked in the Platform and approved by
        the moderation team, unless there is an outage on any or all of the selected Signs. If your
        Content is not presented on a Sign, you will not be charged or will be reimbursed.
    </p>
    <p>
        <b>5.7 Outages.</b> Signs are subject to various outages which may restrict our ability to
        display, edit, or remove Content. If such outages occur, you will only be billed for
        presentations of your Content on a Sign, consistent with your Targets and Budgets. You
        acknowledge that during an outage, the ability to edit, delete, or otherwise change any
        Content that is already in a Sign’s schedule may be delayed for an undefined period of
        time, and you agree that the unmodified Content may continue to be displayed on the Sign
        until the outage is resolved.
    </p>
    <p>
        <b>5.8 Partial Display Failures.</b> Signs are subject to various software, hardware, and
        environmental conditions which may cause Content to be only partially displayed or
        partially visible on the Sign (a “Partial Display Failure”). At our sole discretion, we
        may determine that a Partial Display Failure has reduced the value of the presentation of
        your Content and may, at our sole discretion, reduce the fees associated with such
        presentation or waive them entirely.
    </p>

    <h2>6. Bookings &amp; Programmatic Campaigns</h2>
    <p>
        <b>6.1 Direct Bookings:</b> Bookings confirmed on the Platform are binding, subject to media
        availability.
    </p>
    <p>
        <b>6.2 Programmatic Transactions:</b> Programmatic placements are executed via automated
        bidding and cannot be reversed once executed.
    </p>
    <p>
        <b>6.3 Cancellations:</b> Direct bookings may be canceled only in accordance with TMC’s
        cancellation policy. Programmatic campaigns are non-refundable.
    </p>
    <p>
        <b>6.4 Delivery:</b> While TMC will use reasonable commercial efforts to deliver campaigns,
        no guarantee is given as to impressions, reach, or performance.
    </p>

    <h2>7. Fees &amp; Payments</h2>
    <p>
        <b>7.1 Currency:</b> All fees are payable in USD unless otherwise agreed. You are
        responsible for all taxes and other government charges associated with the display of your
        Content.
    </p>
    <p>
        <b>7.2 Payment Terms:</b> Payment is due in advance unless a credit arrangement is agreed
        under Commercial Transactions Laws.
    </p>
    <p>
        <b>7.3 Late Payments:</b> TMC reserves the right to suspend campaigns and charge statutory
        late interest.
    </p>

    <h2>8. User Content &amp; Intellectual Property</h2>
    <p><b>8.1 Client Ownership:</b> Clients retain ownership of their Content.</p>
    <p>
        <b>8.2 License to TMC:</b> Clients grant TMC and its media partners a non-exclusive,
        worldwide, royalty-free license to use, reproduce, and display Content solely for campaign
        execution.
    </p>
    <p>
        <b>8.3 Warranty:</b> Clients warrant that their Content complies with international laws and
        does not infringe third-party rights.
    </p>

    <h2>9. Data &amp; Privacy</h2>
    <p>
        <b>9.1 Data Processing:</b> TMC collects and processes user data in accordance with Federal
        Decree-Law No. 45 of 2021 on the Protection of Personal Data (PDPL).
    </p>
    <p>
        <b>9.2 Programmatic Sharing:</b> Clients acknowledge that programmatic advertising requires
        data sharing with third-party demand-side and supply-side platforms.
    </p>
    <p>
        <b>9.3 Privacy Policy:</b> Additional details are available in TMC’s
        <a [routerLink]="['/privacy-policy']">Privacy Policy</a>.
    </p>

    <h2>10. Disclaimers &amp; Limitation of Liability</h2>
    <ul>
        <li>Services are provided “as is” and “as available.”</li>
        <li>
            TMC makes no warranties regarding campaign performance, audience reach, or uninterrupted
            access.
        </li>
        <li>
            To the fullest extent permitted under UAE law, TMC disclaims liability for indirect,
            incidental, or consequential damages arising from Service use.
        </li>
    </ul>

    <h2>11. Indemnity</h2>
    <p>
        Clients agree to indemnify and hold harmless TMC, its affiliates, and partners from claims,
        damages, or penalties resulting from:
    </p>
    <ul>
        <li>Non-compliant Content,</li>
        <li>Breach of these Terms, or</li>
        <li>Violations of UAE law or third-party rights.</li>
    </ul>

    <h2>12. Termination</h2>
    <p>TMC may suspend or terminate a Client’s account or campaign if:</p>
    <ul>
        <li>Payments are overdue,</li>
        <li>Content breaches laws and regulations, or</li>
        <li>Client engages in fraudulent or unlawful conduct.</li>
    </ul>

    <h2>13. Governing Law &amp; Dispute Resolution</h2>
    <p>
        <b>13.1 Governing Law:</b> These Terms shall be governed by the laws of the United Arab
        Emirates.
    </p>
    <p>
        <b>13.2 Jurisdiction:</b> Disputes shall first be referred to amicable settlement. Failing
        which, disputes may be resolved by:
    </p>
    <ul>
        <li>The Dubai Courts (default), or</li>
        <li>DIFC-LCIA Arbitration if both parties agree in writing.</li>
    </ul>

    <h2>14. Amendments</h2>
    <p>
        TMC may revise these Terms at any time. Updates will be posted on the Platform. Continued
        use constitutes acceptance of updated Terms.
    </p>

    <h2>15. Contact</h2>
    <div class="legal-contact">
        <p>The Media Connector (TMC)</p>
        <p>Email: <a href="mailto:info@themediaconnector.com">info@themediaconnector.com</a></p>
        <p>Phone: <a href="tel:+971504959458">+971 50 49 59 458</a></p>
        <p>Registered Address: United Arab Emirates, Dubai, Aurora Tower, office 815</p>
        <p>Trade License No.: 101188</p>
    </div>
</div>
